import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Login({ login }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login(email, password);
      navigate('/dashboard/profile');
    } catch (err) {
      setError(err.message || t('loginFailed'));
    }
  };

  const lang = i18n.resolvedLanguage?.split('-')[0] || 'en';

  return (
    <div className="haydi-login" dir={lang === 'ar' ? 'rtl' : 'ltr'} lang={lang}>
      <form className="haydi-login__card" onSubmit={handleSubmit} noValidate>
        <div className="haydi-login__logo">{t('appName')}</div>
        <h1 className="haydi-login__heading">{t('login')}</h1>

        <div className="haydi-login__field">
          <label className="haydi-label" htmlFor="login-email">{t('email')}</label>
          <input
            id="login-email"
            className="haydi-input"
            type="email"
            autoComplete="email"
            placeholder={t('email')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="haydi-login__field">
          <label className="haydi-label" htmlFor="login-password">{t('password')}</label>
          <div style={{ position: 'relative' }}>
            <input
              id="login-password"
              className="haydi-input"
              type={showPassword ? 'text' : 'password'}
              autoComplete="current-password"
              placeholder={t('password')}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              style={{ paddingRight: '2.5rem' }}
            />
            <button
              type="button"
              className="haydi-login__toggle-pw"
              onClick={() => setShowPassword((s) => !s)}
              tabIndex={-1}
              aria-label={showPassword ? t('ariaHidePassword') : t('ariaShowPassword')}
            >
              {showPassword ? '🙈' : '👁'}
            </button>
          </div>
        </div>

        {error && <p className="haydi-login__error">{error}</p>}

        <button type="submit" className="haydi-btn haydi-btn--primary haydi-login__submit">
          {t('login')}
        </button>
      </form>
    </div>
  );
}

export default Login;
